import { Component, OnInit, ViewChild } from '@angular/core';
import { FormControl, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { MatSort } from '@angular/material/sort';
import { MatTableDataSource } from '@angular/material/table';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { ModalAddTradeAgreementComponent } from 'src/app/components/modal-add-trade-agreement/modal-add-trade-agreement.component';
import { ModalMessageComponent } from 'src/app/components/modal-message/modal-message.component';
import { MainService } from 'src/app/services/main.service';
import { UtilsService } from 'src/app/services/utils.service';

@Component({
  selector: 'app-new-trade-agreement',
  templateUrl: './new-trade-agreement.page.html',
  styleUrls: ['./new-trade-agreement.page.scss']
})
export class NewTradeAgreementPage implements OnInit {

  organizationForm: FormGroup = new FormGroup({
    organization_id: new FormControl('', Validators.required),
    charge_frequency: new FormControl('', Validators.required),
    status: new FormControl('', Validators.required),
    // trial_end: new FormControl(''),
    organization_email: new FormControl('---'),
    organization_label: new FormControl('---'),
    organization_phone: new FormControl('---'),
    organization_name_contact: new FormControl('---'),
    organization_city: new FormControl('---'),
    organization_zone: new FormControl('---'),
  });
  customerSelected: boolean = false;
  products_ids: any = [];
  filterTerm: string = '';
  filterTerm2: string = '';
  filterTerm3: string = '';
  id: string;
  organizations: any = [];
  productsServices: any = []
  dataSource: any = [];
  charges: any = this.uService.charges;
  statuses: any = []

  displayedColumns: any = [
    {variable: 'rowNumber', displayedName: 'N.'},
    {variable: 'product_name', displayedName: 'Producto'},
    // {variable: 'badge', displayedName: 'Divisa'},
    {variable: 'trial_price', displayedName: 'Precio prueba'},
    // {variable: 'base_price', displayedName: 'Precio base'},
    {variable: 'product_price_limited', displayedName: 'Precio'},
    // {variable: 'type_pay_traducted', displayedName: 'Tipo de precio'},
    {variable: 'product_line_name', displayedName: 'Linea de producto'},
    {variable: 'options-prod-serv', displayedName: 'Acciones'},
  ];

  constructor(private dialog: MatDialog, private mService: MainService, private toast: ToastrService, private uService: UtilsService, private router: Router, private activatedRoute: ActivatedRoute) {
    this.getOrganizationList();
    this.activatedRoute.params
    .subscribe((respParams: any)=>{
      if(respParams.id){
        this.id = respParams.id;
        this.getData();
      };
    })
    this.getStatus();
    this.uService.eventSetCustomer$.subscribe((resp: any)=>{
      if(resp !== 0){
        this.setCustomer(resp);
      }
    });
  }

  ngOnInit(): void {
  }

  getStatus(){
    this.mService.get_request('enum_status_agreement')
    .subscribe((resp: any)=>{
      this.statuses = resp;
      resp.map((element: any)=>{
        if(element['name'] === 'activo'){
          this.organizationForm.get('status').setValue(element['value'])
        }
      })
    })
  }

  getData(){
    this.mService.get_request('commercial-agreements/list', { id: this.id, status_prod: 'active' })
    .subscribe((resp: any)=>{
      if(resp.status){
        this.organizationForm.get('organization_id').setValue(resp.items[0].id_organization);
        this.organizationForm.get('charge_frequency').setValue(resp.items[0].charge_frequency);
        this.organizationForm.get('status').setValue(resp.items[0].status);
        // this.organizationForm.get('trial_end').setValue(resp.items[0].trial_end);
        this.getDataOrganization();
        this.dataSource = resp.items[0].commercial_agreements_products;
        this.productsServices = resp.items[0].commercial_agreements_products;
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    })
  }

  setFocus(id: any) {
    var input  = document.getElementById(id);
    if(input !== null){
      input.focus();
    }
  }

  setCustomer(id: string){
    this.organizationForm.get('organization_id').setValue(id);
    this.getDataOrganization();
  }

  updateData(data: any){
    this.productsServices = [...data];
  }

  public addtradeAgreement(){
    if(this.customerSelected){
      const dialogRef = this.dialog.open(ModalAddTradeAgreementComponent, {
        // width: '550px',
        disableClose: true,
        data:  {
          dataSource: this.dataSource,
          exclude_ids: this.products_ids
        },
        // panelClass: 'content_modal'
      });

      dialogRef.afterClosed().subscribe(result => {
        if (result != null) {
          var type_pay_traducted: string = '';

          switch (result.type_pay) {
            case 'percentage':
              type_pay_traducted = 'Porcentaje'
            break;
            case 'flat_fee':
              type_pay_traducted = 'Tarifa plana'
            break;
          }
          this.productsServices.push({...result, type_pay_traducted});
          // this.productsServices.push(result);
          this.dataSource = [...this.productsServices];
        }
      });
    }else{
      this.toast.error( 'Por favor seleccione un Cliente / Comercio', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
    }
  }

  public sendApporval(){
    if( this.organizationForm.valid ){
      var id : string = this.organizationForm.get('organization_id').value;
      var charge_frequency : string = this.organizationForm.get('charge_frequency').value;
      var status : string = this.organizationForm.get('status').value;
      // var trial_end : string = this.organizationForm.get('trial_end').value;
      // var arraytoReturn = this.uService.filterSelectedFields(this.dataSource, ['product_price', 'trial_price'])
      var arrayToReturn: any = [];

      this.dataSource.forEach(element => {
        var objectAux: any = {
          product_id: element.id,
          product_price: element.product_price,
          trial_price: element.trial_price,
          trial_end_cap: element.trial_end_cap,
          trial_start: element.trial_start,
          status: element.status,
          price_type: element.price_type
        }

        if(element.quantity != undefined){
          objectAux.quantity = element.quantity;
        }
        if(element.time != undefined){
          objectAux.time = element.time;
        }

        arrayToReturn.push(objectAux);
      });

      var body = {
        organization_id: id,
        status_ca: status,
        charge_frequency: charge_frequency,
        currency_id: 1,
        // trial_end: trial_end,
        products_array: arrayToReturn
      }

      if(body.products_array.length > 0){
        const dialogRef = this.dialog.open(ModalMessageComponent, {
          // width: '550px',
          disableClose: true,
          panelClass: 'content-fit',
          data: {
            title: 'Registrar nuevo acuerdo comercial?'
          },
        });

        dialogRef.afterClosed().subscribe(result => {
          if(result){
            this.createComertialAgreement(body);
          }
        });
      }else{
        this.toast.error( 'Debe Añadir al menos un un producto', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
      }
    }else{
      this.uService.validateForm(this.organizationForm);
    }
  }

  public editApporval(){
    if( this.organizationForm.valid ){
      var id : string = this.organizationForm.get('organization_id').value;
      var charge_frequency : string = this.organizationForm.get('charge_frequency').value;
      var status : string = this.organizationForm.get('status').value;
      // var trial_end : string = this.organizationForm.get('trial_end').value;
      // var arraytoReturn = this.uService.filterSelectedFields(this.dataSource, ['product_price', 'trial_price'])
      var arrayToReturn: any = [];

      this.dataSource.forEach(element => {
        var objectAux = {
          product_id: element.id,
          product_price: element.product_price,
          trial_price: element.trial_price,
          trial_end_cap: element.trial_end_cap,
          trial_start: element.trial_start,
          id_cap: element.id_cap,
          status: element.status,
          price_type: element.price_type
        }
        arrayToReturn.push(objectAux);
      });

      var body = {
        id_com_agr: this.id,
        organization_id: id,
        status_ca: status,
        charge_frequency: charge_frequency,
        currency_id: 1,
        // trial_end: trial_end,
        products_array: arrayToReturn
      }

      if(body.products_array.length > 0){
        const dialogRef = this.dialog.open(ModalMessageComponent, {
          // width: '550px',
          disableClose: true,
          panelClass: 'content-fit',
          data: {
            title: 'Editar acuerdo comercial?'
          },
        });

        dialogRef.afterClosed().subscribe(result => {
          if(result){
            this.editComertialAgreement(body);
          }
        });
      }else{
        this.toast.error( 'Debe Añadir al menos un un producto', 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
      }
    }else{
      this.uService.validateForm(this.organizationForm);
    }

  }

  createComertialAgreement( body: any ){
    this.mService.post_request('full-commercial-agreement/create', body)
    .subscribe((resp: any)=>{
      if(resp.status){
        this.toast.success(resp.message, 'Exito', {timeOut: 5000, progressBar: true, closeButton: true});
        this.router.navigate(['/dashboard/trade-agreements']);
      }else{
        if(resp?.errors != undefined){
          resp.errors.forEach(element => {
            this.toast.error( element, resp.message, {timeOut: 5000, progressBar: true, closeButton: true});
          });
        }
      }
    })
  }

  editComertialAgreement(body: any){
    this.mService.post_request('full-commercial-agreement/create', body)
    .subscribe((resp: any)=>{

      if(resp.status){
        this.toast.success(resp.message, 'Exito', {timeOut: 5000, progressBar: true, closeButton: true});
        this.router.navigate(['/dashboard/trade-agreements']);
      }else{
        if(resp?.errors != undefined){
          resp.errors.forEach(element => {
            this.toast.error( element, resp.message, {timeOut: 5000, progressBar: true, closeButton: true});
          });
        }
      }
    });

    // if(body.products_array.length > 0){
    //   body.products_array.forEach(product => {
    //     id_caps.push(product.id_cap);
    //   });

    //   console.log(id_caps, 'id_com_agr_pro');

    //   this.mService.delete_request('commercial-agreements-product/delete ', { id_com_agr_pro: id_caps})
    //   .subscribe((resp: any)=>{
    //     if(resp.status){
    //       console.log(resp);
    //     }else{
    //       if(resp?.errors != undefined){
    //         resp.errors.forEach(element => {
    //           this.toast.error( element, resp.message, {timeOut: 5000, progressBar: true, closeButton: true});
    //         });
    //       }
    //     }
    //   })
    // }
  }

  getDataOrganization(){
    var id = this.organizationForm.get('organization_id').value;

    this.customerSelected = true;
    // reset fields
    this.organizationForm.get('organization_label').setValue('---');
    this.organizationForm.get('organization_phone').setValue('---');
    this.organizationForm.get('organization_name_contact').setValue('---');
    this.organizationForm.get('organization_city').setValue('---');
    this.organizationForm.get('organization_zone').setValue('---');
    this.organizationForm.get('organization_email').setValue('---');

    this.mService.get_request('full_organization', { id: id })
    .subscribe((resp: any)=>{
      if(resp.status){
        var organization = resp.items;

        this.organizationForm.get('organization_label').setValue(organization?.label_organization);
        this.organizationForm.get('organization_phone').setValue(organization?.cellphone_contact);
        this.organizationForm.get('organization_name_contact').setValue(organization?.first_name_contact + ' ' + organization?.last_name_contact || '---');
        if (organization.branch_offices != null) {
          this.organizationForm.get('organization_city').setValue(organization?.branch_offices[0]?.city || '---');
          this.organizationForm.get('organization_zone').setValue(organization?.branch_offices[0]?.zone || '---');
        }
        this.organizationForm.get('organization_email').setValue(organization?.email);

      }else{
        if(resp.message){
          this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
          if(resp.message.includes('expirado')){
            this.uService.logOut$.next(true);
          }
        }
      }
    })
    this.mService.get_request('commercial-agreements/list', { organization_id: id })
    .subscribe((resp: any)=>{

      if(resp.status){
        this.products_ids = resp.products_ids;
      }
    })
  }

  getOrganizationList(){
    this.mService.get_request('organizations/list')
    .subscribe((resp: any)=>{
      if(resp.status){
        this.organizations = resp.items;
      }else{
        this.toast.error(resp.message, 'Error', {timeOut: 5000, progressBar: true, closeButton: true});
        if(resp.message.includes('expirado')){
          this.uService.logOut$.next(true);
        }
      }
    });
  }
}
